/**
 * Selector de elementos enfocables para el focus-trap del popover. A diferencia
 * del equivalente de `SideSheet`, la cláusula de `button` excluye explícitamente
 * `tabindex="-1"`: la grilla de `Calendar` usa foco itinerante (roving tabindex —
 * un único día con `tabIndex={0}`, el resto en `-1`), y sin esta exclusión
 * `querySelectorAll` devolvería como "último enfocable" un día no alcanzable de
 * verdad por `Tab` (el navegador ya los salta), rompiendo el ciclo del trap.
 */
export const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled]):not([tabindex="-1"])',
  'textarea:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',')

export const DEFAULT_TRIGGER_LABEL = 'Seleccionar fecha en calendario'
export const DEFAULT_DIALOG_LABEL = 'Calendario de selección de fecha'

/**
 * Dimensiones de las flechas de avance/retroceso — mismo ancho/alto que un
 * botón de día de `DayStrip` (`min-width: 44px`, `height: var(--spacing-10)`
 * = 56px), fiel al diseño de referencia (`eci-firefly-uikit`, `DateStrip`:
 * "Mismo ancho/alto que un botón de día (44×56px)"). El botón de calendario
 * completo (`.trigger`, `DatePicker.module.scss`) usa la misma medida para
 * que los tres controles (flecha, tira, calendario) compartan un único alto
 * de fila.
 */
export const ARROW_SIZE = { width: 44, height: 56 } as const

export const DEFAULT_RANGE_TOGGLE_LABEL = 'Seleccionar rango de fechas'
